import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import classes from './index.module.scss'

const SystemNotificationsFallback = ({ value, isPopup, isAll }) => {
  return (
    <Element
      className={[classes.container, isPopup && 'justifyContentCenter'].join(
        ' ',
      )}
      style={{
        backgroundColor: isPopup ? '#ffffff' : '#F3F3F3',
        color: '#9C9C9C',
        paddingTop: isPopup ? 0 : 80,
      }}
    >
      <Icon
        style={{ fontSize: isPopup ? 26 : 56 }}
        className="icon-notifications"
      />
      {isAll && (
        <Element
          className={classes.text}
          style={{
            fontSize: isPopup ? 18 : 22,
            color: '#9C9C9C',
            fontWeight: 600,
          }}
        >
          <Translate value={'systemNotifications.NO_NOTIFICATIONS'} />
        </Element>
      )}
      <Element className={classes.text} style={{ fontSize: isPopup ? 16 : 20 }}>
        <Translate value={value} />
      </Element>
    </Element>
  )
}

SystemNotificationsFallback.propTypes = {
  value: PropTypes.string.isRequired,
  isPopup: PropTypes.bool,
  isAll: PropTypes.bool,
}

export default SystemNotificationsFallback
